
<div class="modal-dialog-alert" role="document">
  <div class="modal-content v-card card modal-card">
    <div class="modal-header">
      <div class="modal-title">{{ title }}</div>
      <div>
        @if (!raw && showExpanded) {
          <button (click)="expanded = !expanded" class="v-btn btn btn-sm me-2" [ngClass]="{ 'btn-secondary': expanded, 'btn-outline-secondary': !expanded }" style="box-shadow: none; border: none;">Expand</button>
        }
        @if (showRaw) {
          <button (click)="raw = !raw;" class="v-btn btn btn-sm" [ngClass]="{ 'btn-secondary': raw, 'btn-outline-secondary': !raw }" style="box-shadow: none; border: none;">Raw</button>
        }
      </div>
    </div>

    <div class="modal-body">
      @if (bodyTitle) {
        <div class="fs-16 mb-3">{{ bodyTitle }}</div>
      }

      @if (jsonTitle) {
        <div class="fs-14 mb-1">{{ jsonTitle }}</div>
      }
      @if (json) {
        <div class="viewer-wrapper mb-3">
          @if (raw) {
            <pre>{{ json | json }}</pre>
          }
          @if (!raw) {
            <ngx-json-viewer [json]="json" [expanded]="expanded"></ngx-json-viewer>
          }
        </div>
      }
      @if (json2Title) {
        <div class="fs-14 mb-1">{{ json2Title }}</div>
      }
      @if (json2) {
        <div class="viewer-wrapper">
          @if (raw) {
            <pre>{{ json2 | json }}</pre>
          }
          @if (!raw) {
            <ngx-json-viewer [json]="json2" [expanded]="expanded"></ngx-json-viewer>
          }
        </div>
      }
    </div>

    <div class="card-footer modal-card-footer">
      <button class="v-btn vsight-button left btn vsight-button-outline-secondary btn-outline-secondary" (click)="modalRef.hide()">Close</button>
    </div>
  </div>
</div>